<template>
  <div>
    <a-row :gutter="16">
      <a-col span="24">
        <div class="panel panel-default panel-stretch">
          <div class="panel-heading">
            Verzekeringen
          </div>

          <div class="panel-body no-padding">
            <a-row>
              <a-col :span="6" style="padding: 1.5rem; border-right: 1px solid #eeeeee">
                <div class="form-group">
                  <label class="control-label">
                    Klant type
                  </label>
                  <a-select
                    v-model="filter.customerType"
                    mode="multiple"
                    placeholder="Selecteer klant type"
                    style="width: 100%"
                  >
                    <a-select-option v-for="(value, idx) in customerTypes" :key="idx" :value="idx">
                      {{ value }}
                    </a-select-option>
                  </a-select>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Kantoor
                  </label>
                  <a-select v-model="filter.office"
                            v-if="!loadingOffices"
                            allowClear
                            placeholder="Selecteer kantoor"
                            style="width: 100%">
                    <a-select-option v-for="office in offices" :key="office.id" :value="office.id">
                      {{ office.name }}
                    </a-select-option>
                  </a-select>
                  <Skeleton v-else :loading="loadingOffices" height="32"></Skeleton>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Adviseur
                  </label>
                  <a-select v-model="filter.advisor"
                            v-if="!loadingUsers"
                            allowClear
                            placeholder="Selecteer adviseur"
                            style="width: 100%">
                    <a-select-option v-for="advisor in users" :key="advisor.id" :value="advisor.id">
                      {{ advisor.first_name }} {{ advisor.last_name }}
                    </a-select-option>
                  </a-select>
                  <Skeleton v-else :loading="loadingUsers" height="32"></Skeleton>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Hoofdgroep
                  </label>
                  <a-select v-model="filter.branchId"
                            v-if="!loadingBranches"
                            placeholder="Selecteer hoofdgroep"
                            allowClear
                            @change="getViewGroupByBranch(true)"
                            style="width: 100%">
                    <a-select-option v-for="(value, idx) in branches" :key="idx" :value="idx">
                      {{ value }}
                    </a-select-option>
                  </a-select>
                  <Skeleton v-else :loading="loadingBranches" height="32"></Skeleton>
                </div>

                <div class="form-group" v-if="filter.branchId !== undefined">
                  <label class="control-label">
                    Soort polis
                  </label>
                  <a-select v-model="filter.viewGroup"
                            v-if="!loadingViewGroup"
                            placeholder="Selecteer soort polis"
                            mode="multiple"
                            allowClear
                            style="width: 100%">
                    <a-select-option v-for="(value, idx) in viewGroup" :key="idx" :value="idx">
                      {{ value }}
                    </a-select-option>
                  </a-select>
                  <Skeleton v-else :loading="loadingViewGroup" height="32"></Skeleton>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Status
                  </label>
                  <a-select v-model="filter.status"
                            allowClear
                            mode="multiple"
                            placeholder="Selecteer status(sen)"
                            style="width: 100%">
                    <a-select-option v-for="(idx, value) in PolicyMutationCodeEnum" :key="idx" :value="idx">
                      {{ PolicyMutationDisplayEnum[value] }}
                    </a-select-option>
                  </a-select>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Periode: Ingangsdatum
                  </label>
                  <a-range-picker
                    v-model="filter.startDateRange"
                    :format="DateFormatEnum.DISPLAY_DATE"
                    :default-value="defaultStartDateRange"
                    :placeholder="['Startdatum', 'Einddatum']"
                    :allow-clear="true"
                    :ranges="defaultDatePickerRanges"
                    style="width: 100%">
                    <a-icon slot="suffixIcon" type="calendar"/>
                  </a-range-picker>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Periode: Premie vervaldatum
                  </label>
                  <a-range-picker
                      v-model="filter.expirationDateRange"
                      :format="DateFormatEnum.DISPLAY_DATE"
                      :default-value="defaultExpirationDateRange"
                      :placeholder="['Startdatum', 'Einddatum']"
                      :allow-clear="true"
                      :ranges="defaultDatePickerRanges"
                      style="width: 100%">
                    <a-icon slot="suffixIcon" type="calendar"/>
                  </a-range-picker>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Periode: Contract vervaldatum
                  </label>
                  <a-range-picker
                      v-model="filter.contractExpirationDateRange"
                      :format="DateFormatEnum.DISPLAY_DATE"
                      :default-value="defaultContractExpirationDateRange"
                      :placeholder="['Startdatum', 'Einddatum']"
                      :allow-clear="true"
                      :ranges="defaultDatePickerRanges"
                      style="width: 100%">
                    <a-icon slot="suffixIcon" type="calendar"/>
                  </a-range-picker>
                </div>

                <div class="form-group">
                  <label class="control-label">
                    Periode: Mutatiedatum
                  </label>
                  <a-range-picker
                      v-model="filter.mutationDateRange"
                      :format="DateFormatEnum.DISPLAY_DATE"
                      :default-value="defaultMutationDateRange"
                      :placeholder="['Startdatum', 'Einddatum']"
                      :allow-clear="true"
                      :ranges="defaultDatePickerRanges"
                      style="width: 100%">
                    <a-icon slot="suffixIcon" type="calendar"/>
                  </a-range-picker>
                </div>

                <div class="form-group">
                  <a-button @click="getPolicies()" :loading="loadingPolicies" type="primary" style="width: 100%">
                    Zoek met deze filters
                  </a-button>

                  <div style="margin-top: 0.2em">
                    <a-button type="link" @click="resetFilters">
                      Reset filters
                    </a-button>

                    <a-button v-if="!filterSaved"
                              @click="saveFiltersInCache"
                              type="link"
                              class="pull-right"
                    >
                      Onthoud filters
                    </a-button>
                  </div>
                </div>
              </a-col>

              <a-col :span="17" style="padding: 1.5rem 0 1.5rem 1.5rem;">
                <a-spin tip="laden..." :spinning="loadingPolicies">

                  <div class="row">
                    <div class="col-md-6">
                      <div style="margin-bottom: 20px">
                        <strong>{{ totalPolicies }} {{ PoliciesDescription }}</strong>
                      </div>
                    </div>
                    <div class="col-md-6 pull-right">
<!--                      <a-button type="primary" :href="exportHref" target="_blank" style="float: right">-->
<!--                        Export naar excel-->
<!--                      </a-button>-->
                    </div>
                  </div>

<!--                  <a-switch v-model:checked="showBasicInfo"/>-->
<!--                  Toon basis informatie-->
<!--                  <br/>-->
<!--                  <a-switch v-model:checked="showAmounts"/>-->
<!--                  Toon bedragen-->
<!--                  <br/>-->
<!--                  <a-switch v-model:checked="showDates"/>-->
<!--                  Toon datums-->

<!--                  <br/><br/>-->

<!--                  <a-select mode="tags" v-model="selectedColumns" style="width: 100%">-->
<!--                    <a-select-option v-for="column in allTableColumns" :key="column.value">{{-->
<!--                        column.title-->
<!--                      }}-->
<!--                    </a-select-option>-->
<!--                  </a-select>-->
<!--                  <small>De geselecteerde columns worden onthouden</small>-->

<!--                  <br/><br/>-->

<!--                  <div style="overflow-x: auto">-->
<!--                    <table class="table table-striped">-->
<!--                      <thead>-->
<!--                      <tr>-->
<!--                        <th class="compact" v-for="column in getTableColumns">-->
<!--                          <order-by :order="filter.order || 'undefined'" :select="filter.orderBy" :value="column.value"-->
<!--                                    @change="onOrderByChange">-->
<!--                            {{ column.title }}-->
<!--                          </order-by>-->
<!--                        </th>-->
<!--                      </tr>-->
<!--                      </thead>-->

<!--                      <tbody>-->
<!--                      <PolicyRowComponent v-for="policy in policies"-->
<!--                                            :key="policy.id"-->
<!--                                            :mortgage="policy"-->
<!--                                            :table-columns="getTableColumns"-->
<!--                      ></PolicyRowComponent>-->
<!--                      </tbody>-->
<!--                    </table>-->
<!--                  </div>-->

<!--                  <div v-if="hasPolicies" class="panel-body" style="padding-top: 0;">-->
<!--                    <laravel-pagination-->
<!--                        v-if="displayPagination"-->
<!--                        :data="currentRequestData"-->
<!--                        @pagination-change-page="getPolicies"-->
<!--                        style="margin: 0;"-->
<!--                    ></laravel-pagination>-->
<!--                  </div>-->

                </a-spin>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {Skeleton} from 'vue-loading-skeleton'
import PolicyRowComponent from "./PolicyRowComponent"
import policyApi from '~/api/policy'
import insuranceApi from '~/api/insurance'
import officeApi from '~/api/office'
import userApi from '~/api/user'
import moment from 'moment'
import DateFormatEnum from "~/enums/DateFormatEnum";
import PolicyMutationCodeEnum from "~/enums/PolicyMutationCodeEnum";
import PolicyMutationDisplayEnum from "~/display_enums/PolicyMutationDisplayEnum";

export default {
  name: "ReportingPoliciesOverviewComponent",
  mounted() {
    this.loadingOffices = true
    this.loadingUsers = true
    this.loadingBranches = true

    officeApi.paginateOffices(1, 500).then(response => {
      this.offices = response.data
    }).catch(() => {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om de kantoren te laden',
      });
    }).finally(() => {
      this.loadingOffices = false
    })

    insuranceApi.getBranches().then((response) => {
      this.branches = response
    }).catch(() => {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om de hoofdgroepen te laden',
      });
    }).finally(() => {
      this.loadingBranches = false
    })

    userApi.paginateActive(1, 500).then(response => {
      this.users = response.data
    }).catch(() => {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om de adviseurs te laden',
      });
    }).finally(() => {
      this.loadingUsers = false
    })

    this.checkLocalStorageForSettings();
    this.getPolicies();
  },
  data() {
    return {
      DateFormatEnum,
      PolicyMutationCodeEnum,
      PolicyMutationDisplayEnum,
      customerTypes: {
        '1': 'Particulier',
        '9': 'Zakelijk',
      },
      offices: [],
      notaries: [],
      users: [],
      defaultDatePickerRanges: {
        [moment().format('YYYY') + ' - nu']: [
          moment().startOf('year'),
          moment()
        ],
        [moment().subtract(1, 'year').format('YYYY')]: [
          moment().subtract(1, 'year').startOf('year'),
          moment().subtract(1, 'year').endOf('year')
        ],
        [moment().subtract(2, 'year').format('YYYY')]: [
          moment().subtract(2, 'year').startOf('year'),
          moment().subtract(2, 'year').endOf('year')
        ],
        [moment().subtract(3, 'year').format('YYYY')]: [
          moment().subtract(3, 'year').startOf('year'),
          moment().subtract(3, 'year').endOf('year')
        ],
        [moment().subtract(4, 'year').format('YYYY')]: [
          moment().subtract(4, 'year').startOf('year'),
          moment().subtract(4, 'year').endOf('year')
        ],
      },
      defaultStartDateRange: [
        moment().subtract(1, 'year').startOf('year'),
        moment().subtract(1, 'year').endOf('year')
      ],
      defaultExpirationDateRange: [],
      defaultContractExpirationDateRange: [],
      defaultMutationDateRange: [],
      branches: undefined,
      viewGroup: [],
      filter: {
        branchId: undefined,
        viewGroup: [],
        office: undefined,
        status: [],
        customerType: [
          '1',
          '9',
        ],
        orderBy: 'created_at',
        order: 'desc',
        startDateRange: [
          moment().subtract(1, 'year').startOf('year'),
          moment().subtract(1, 'year').endOf('year')
        ],
        expirationDateRange: [],
        contractExpirationDateRange: [],
        mutationDateRange: [],
      },
      filterUsedInSearch: {},
      mortgages: [],
      totalPolicies: 0,
      loadingPolicies: false,
      loadingOffices: false,
      loadingUsers: false,
      loadingBranches: false,
      loadingViewGroup: false,
      currentRequestData: {},
      filterSaved: false,
      // allTableColumns: [
      //   {
      //     title: 'Klant',
      //     value: 'customer'
      //   },
      //   {
      //     title: 'Hypotheeknummer',
      //     value: 'hypotheeknummer'
      //   },
      //   {
      //     title: 'Onderpand adres',
      //     value: 'onderpandsgegevens'
      //   },
      //   {
      //     title: 'Passeerdatum',
      //     value: 'passeerdatum'
      //   },
      //   {
      //     title: 'Marktwaarde',
      //     value: 'marktwaarde'
      //   },
      //   {
      //     title: 'Geldverstrekker',
      //     value: 'agency_name'
      //   },
      //   {
      //     title: 'Productnaam',
      //     value: 'company_label_description'
      //   },
      //   {
      //     title: 'Hypothecaire inschrijving',
      //     value: 'hypotheciareInschrijving'
      //   },
      //   {
      //     title: 'Oorspronkelijk hypotheekbedrag',
      //     value: 'principal_sum'
      //   },
      //   {
      //     title: 'Resterend hypotheekbedrag',
      //     value: 'remaining_principal_sum'
      //   },
      //   {
      //     title: 'Aflossingsvrij',
      //     value: 'remaining_interest_only_sum'
      //   },
      //   {
      //     title: 'Datum ontbindende voorwaarde',
      //     value: 'end_financing_reservation_date'
      //   },
      //   {
      //     title: 'Datum bankgarantie',
      //     value: 'bank_guarantee_date'
      //   },
      //   {
      //     title: 'Ongetekend renteaanbod geldig tot',
      //     value: 'validity_unsigned_offer_date'
      //   },
      //   {
      //     title: 'Getekend renteaanbod geldig tot',
      //     value: 'validity_signed_offer_date'
      //   },
      //   {
      //     title: 'Offerte ongetekend geldig tot',
      //     value: 'final_offer_date'
      //   },
      //   {
      //     title: 'Offerte getekend geldig tot',
      //     value: 'offer_expire_date'
      //   },
      //   {
      //     title: 'Geldigheidsduur offerte te verlengen tot',
      //     value: 'quotation_extend_date'
      //   }
      // ],
      // selectedColumns: [],
      // basicColumns: [
      //   'customer',
      //   'hypotheeknummer',
      //   'onderpandsgegevens',
      //   'passeerdatum',
      //   'marktwaarde',
      //   'agency_name',
      //   'company_label_description',
      // ],
      // amountColumns: [
      //   'hypotheciareInschrijving',
      //   'principal_sum',
      //   'remaining_principal_sum',
      //   'remaining_interest_only_sum',
      // ],
      // dateColumns: [
      //   'end_financing_reservation_date',
      //   'bank_guarantee_date',
      //   'validity_unsigned_offer_date',
      //   'validity_signed_offer_date',
      //   'final_offer_date',
      //   'offer_expire_date',
      //   'quotation_extend_date',
      // ]
    }
  },
  computed: {
    PoliciesDescription() {
      return this.policies && this.policies.length === 1 ? 'verzekering' : 'verzekeringen';
    },
    // hasPolicies() {
    //   return (this.initialized && this.policies.length > 0) || !this.initialized;
    // },
    // displayPagination() {
    //   return typeof this.currentRequestData.meta !== "undefined";
    // },
    // getTableColumns() {
    //   return this.allTableColumns.filter(column => this.selectedColumns.includes(column.value));
    // },
    // exportHref() {
    //   let uri = "/web_api/v1/policies/filtered/export?";
    //   let params = '';
    //   let filter = this.filterUsedInSearch;
    //
    //   params += '&columns=' + this.selectedColumns.toString();
    //
    //   filter.showBasicInfo = this.showBasicInfo
    //   filter.showAmounts = this.showAmounts
    //   filter.showDates = this.showDates
    //   Object.keys(this.filterUsedInSearch).forEach(function (key) {
    //     if (filter[key] !== undefined) {
    //       params += '&' + key + '=' + filter[key]
    //     }
    //   });
    //   uri += params.substring(1);
    //   return uri
    // },
    // showBasicInfo: {
    //   get() {
    //     return this.allInSelectedColumns(this.basicColumns)
    //   },
    //   set(value) {
    //     if (value === true) {
    //       this.selectedColumns = _.union(this.selectedColumns, this.basicColumns)
    //     } else {
    //       this.selectedColumns = this.selectedColumns.filter(column => !this.basicColumns.includes(column))
    //     }
    //   }
    // },
    // showAmounts: {
    //   get() {
    //     return this.allInSelectedColumns(this.amountColumns)
    //   },
    //   set(value) {
    //     if (value === true) {
    //       this.selectedColumns = _.union(this.selectedColumns, this.amountColumns)
    //     } else {
    //       this.selectedColumns = this.selectedColumns.filter(column => !this.amountColumns.includes(column))
    //     }
    //   }
    // },
    // showDates: {
    //   get() {
    //     return this.allInSelectedColumns(this.dateColumns)
    //   },
    //   set(value) {
    //     if (value === true) {
    //       this.selectedColumns = _.union(this.selectedColumns, this.dateColumns)
    //     } else {
    //       this.selectedColumns = this.selectedColumns.filter(column => !this.dateColumns.includes(column))
    //     }
    //   }
    // },
  },
  methods: {
    moment,
    getPolicies(page = 1) {
      this.loadingPolicies = true

      let filter = {...this.filter};

      filter.include = ['customer'];
      filter.page = page;

      // "Deep copy" remove reactivity and format date range
      // NOTE: first day of the year will be parsed to last day of previous year at 23.00
      // EG: 2021-01-01 00:00:00 -> 2020-12-31 23:00:00
      this.filterUsedInSearch = JSON.parse(JSON.stringify(filter));

      let filterParameters = {
        'customer_type': filter.customerType,
        'office': filter.office,
        'advisor': filter.advisor,
        'branch_id': filter.branchId,
        'view_group': filter.viewGroup,
        'status': filter.status,
        'start_date_range': filter.startDateRange,
        'expiration_date_range': filter.expirationDateRange,
        'contract_expiration_date_range': filter.contractExpirationDateRange,
        'mutation_date_range': filter.mutationDateRange,
        'order': filter.order,
        'order_by': filter.orderBy,
        'page': filter.page,
        'include': filter.include,
      }

      // format moment to date-strings
      filterParameters = JSON.parse(JSON.stringify(filterParameters));

      policyApi.getPoliciesByFilter(filterParameters).then(response => {
        this.policies = response.data;
        this.currentRequestData = response;

        if (response && response.meta && response.meta.pagination && response.meta.pagination.total) {
          this.totalPolicies = response.meta.pagination.total
        } else if (response.data && response.data.length > 0) {
          this.totalPolicies = response.data.length
        } else {
          this.totalPolicies = 0;
        }
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om verzekeringen te laden',
        });
      }).finally(() => {
        this.loadingPolicies = false
      })
    },
    getViewGroupByBranch(clearViewGroup = true) {
      this.loadingViewGroup = true
      this.viewGroup = []

      if (clearViewGroup === true) {
        this.filter.viewGroup = []
      }

      if (this.filter.branchId === undefined) {
        this.loadingViewGroup = false
        return
      }

      insuranceApi.getViewGroupByBranch(this.filter.branchId).then(response => {
        this.viewGroup = response
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om de hoofdgroepen te laden',
        });
      }).finally(() => {
        this.loadingViewGroup = false
      })
    },
    resetFilters() {
      this.filter = {
        branches: undefined,
        advisor: undefined,
        viewGroup: [],
        office: undefined,
        status: [],
        customerType: [
          '1',
          '9',
        ],
        orderBy: 'created_at',
        order: 'desc',
        startDateRange: this.defaultStartDateRange,
        expirationDateRange: this.defaultExpirationDateRange,
        contractExpirationDateRange: this.defaultContractExpirationDateRange,
        mutationDateRange: this.defaultMutationDateRange,
      }

      if (localStorage.getItem('reporting-policy-filter')) {
        localStorage.removeItem('reporting-policy-filter')
        this.filterSaved = false
      }

      this.getPolicies()
    },
    // onOrderByChange(orderBy, order) {
    //   this.filter.orderBy = orderBy
    //   this.filter.order = order
    //   this.getPolicies();
    // },
    saveFiltersInCache() {
      localStorage.setItem('reporting-policy-filter', JSON.stringify(this.filter))
      this.filterSaved = true
    },
    checkLocalStorageForSettings() {
      let storedFilter = localStorage.getItem('reporting-policy-filter')

      if (storedFilter !== null) {
        this.filter = JSON.parse(storedFilter)

        if (this.filter.startDateRange) {
          this.filter.startDateRange = this.filter.startDateRange.map(date => moment(date))
        }

        if (this.filter.expirationDateRange) {
          this.filter.expirationDateRange = this.filter.expirationDateRange.map(date => moment(date))
        }

        if (this.filter.contractExpirationDateRange) {
          this.filter.contractExpirationDateRange = this.filter.contractExpirationDateRange.map(date => moment(date))
        }

        if (this.filter.mutationDateRange) {
          this.filter.mutationDateRange = this.filter.mutationDateRange.map(date => moment(date))
        }

        // This timeout is to counteract the watcher for this initial filter set.
        setTimeout(() => this.filterSaved = true, 0)

        if (this.filter.branchId !== undefined) {
          this.getViewGroupByBranch(false)
        }
      }

      // let storedColumns = localStorage.getItem('reporting-policy-columns')
      //
      // if (storedColumns) {
      //   this.selectedColumns = JSON.parse(storedColumns)
      // } else {
      //   this.selectedColumns = [...this.basicColumns]
      // }
    },
    // allInSelectedColumns(columns) {
    //   return this.selectedColumns.length !== 0 && columns.every(columnValue => this.selectedColumns.includes(columnValue))
    // },
  },
  watch: {
    filter: {
      handler() {
        this.filterSaved = false
      },
      deep: true
    },
    selectedColumns(newValue) {
      localStorage.setItem('reporting-policy-columns', JSON.stringify(newValue))
    }
  },

  components: {
    Skeleton,
    PolicyRowComponent,
  },
}
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>